import { useMemo, useState } from "react";
import { recommendItems, recommendTags } from "@/mocks/recommendations";
import SectionHeading from "./SectionHeading";

export default function RecommendSection() {
  const [tag, setTag] = useState("全部");

  const visibleItems = useMemo(() => {
    if (tag === "全部") return recommendItems;
    return recommendItems.filter((item) => item.tag === tag);
  }, [tag]);

  return (
    <section id="recommend" className="section-anchor w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="max-w-7xl mx-auto">
          <SectionHeading
            eyebrow="电影推荐"
            title="潘金莲电影推荐：按方向挑选"
            desc="下面按内容方向整理了几类值得留意的观看选择。点击标签即可筛选，只保留符合该方向的条目，方便你对照挑选。"
          />

          <div
            role="tablist"
            aria-label="推荐方向筛选"
            className="mt-8 flex flex-wrap gap-2"
          >
            {recommendTags.map((t) => (
              <button
                key={t}
                type="button"
                role="tab"
                aria-selected={tag === t}
                onClick={() => setTag(t)}
                className={`px-4 py-2 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap border ${
                  tag === t
                    ? "bg-primary-500 text-background-50 border-primary-500"
                    : "bg-background-100 text-foreground-700 border-background-200/70 hover:border-primary-300"
                }`}
              >
                {t}
              </button>
            ))}
          </div>

          <p className="mt-4 text-xs md:text-sm text-foreground-500">
            当前方向：<span className="text-foreground-800 font-medium">{tag}</span>
            ，共 {visibleItems.length} 条
          </p>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {visibleItems.map((item) => (
              <article
                key={item.id}
                className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden flex flex-col"
              >
                <div className="w-full h-56 overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} 的推荐示意配图`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center justify-between gap-3">
                    <span className="px-2.5 py-1 rounded-full text-xs bg-accent-100 text-accent-900">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500 font-label">
                      {item.era}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-base md:text-lg font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700 flex-1">
                    {item.desc}
                  </p>
                </div>
              </article>
            ))}
          </div>

          {visibleItems.length === 0 && (
            <div className="mt-6 rounded-lg bg-background-100 border border-background-200/70 p-8 text-center text-sm text-foreground-600">
              该方向暂无可显示条目，试试选择其他标签。
            </div>
          )}
        </div>
      </div>
    </section>
  );
}